import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Main from "./detail/main";
import style from "css/lecture.module.css";
import Lab from "./detail/lab";
import ClassRoom from "./detail/classRoom";
import Group from "./detail/group";
import Laboratory from "./detail/laboratory";

function LectureRoomMain() {
  return (
    <div className={style.fontsize}>
      <Routes>
        <Route path="classRoom" element={<ClassRoom />} />
        <Route path="group" element={<Group />} />
        <Route path="lab" element={<Lab />} />
        <Route path="laboratory" element={<Laboratory />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default LectureRoomMain;
